import { render } from "./ActivityPage.vue?vue&type=template&id=1d0ce8ab&ts=true"
import script from "./ActivityPage.vue?vue&type=script&lang=ts"
export * from "./ActivityPage.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__